import { render } from "./clientadd.vue?vue&type=template&id=678e02ce&scoped=true"
import script from "./clientadd.vue?vue&type=script&lang=js"
export * from "./clientadd.vue?vue&type=script&lang=js"

import "./clientadd.vue?vue&type=style&index=0&id=678e02ce&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-678e02ce"]])

export default __exports__